// extracted by mini-css-extract-plugin
module.exports = {"navBox":"style_navBox__3VP8A"};